<template>
  <span>
    <el-autocomplete
        :disabled="disabled"
        @clear="clearAll"
        @keyup.native="clearParentModel"
        v-alphanumeric-validation
        v-model="localModel"
        clearable
        size="mini"
        :placeholder="placeholder"
        :fetch-suggestions="querySearchAsync"
        :highlight-first-item="true"
        @select="handleSelect"
        :trigger-on-focus="false"
        :style="styles"
        :class="classCss || 'width-100p'"
        :maxlength="maxlength"
        :popper-append-to-body="popperAppendToBody"
        @keydown.tab.native="selectWithTab"
        popper-class="autocomplete-popper"
        ref="autocomplete-principal"
        >
    </el-autocomplete>
  </span>
</template>

<script>
import constants from '@/utils/constants';
import autocompleteApiService from '@/api/autocompleteService';

const updateModelEvent = 'update:model';
const updateTextEvent = 'update:text';
const autocompletePrincipalRefStr = 'autocomplete-principal';
export default {
  name: 'MasterRecordAutocomplete',
  data() {
    return {
      localModel: null,
      list: []
    };
  },
  props: {
    /* The model of parent that must be updated when user select option. */
    model: {
      default: null
    },
    /* Additional model of parent that must be updated when user select option with other value of item selected. */
    modelAdditional: {
      default: null
    },
    /* End Point Url to search data. */
    url: {
      type: String,
      default: null
    },
    /* Current ShipperAccountId. */
    shipperAccountId: {
      type: Number,
      default: null
    },
    /* filter by warehouseId. */
    warehouseId: {
      type: Number,
      default: null
    },
    includeInactive: {
      type: Boolean,
      default: null
    },
    maxlength: {
      type: Number,
      default: 100
    },
    /* If the autocomplete item must be selected to change the parent model. */
    strict: {
      type: Boolean,
      default: true
    },
    /* The attribute name of item that must be show in the options of autocomplete. */
    labelField: {
      type: String,
      default: null
    },
    /* The attribute name of item that must be show in the options of autocomplete concatenated with dash after labelField. */
    labelFieldLastWithDash: {
      type: String,
      default: null
    },
    /* Optional: If the value that we need to show is diferent to labelField. */
    labelfieldSelected: {
      type: String,
      default: null
    },
    /* The attribute name of item that must be updated the model. */
    valueField: {
      type: String,
      default: null
    },
    /* The attribute name of item that must be updated the modelAdditional. */
    valueFieldAdditional: {
      type: String,
      default: null
    },
    styles: {
      type: String,
      default: null
    },
    classCss: {
      type: String,
      default: null
    },
    /* The function of parent that must be executed on key enter. */
    enterKeyAction: {
      type: Function,
      default: null
    },
    /* The function of parent that must be executed on select. */
    selectAction: {
      type: Function,
      default: null
    },
    /* The function of parent that must be executed on clear. */
    clearAction: {
      type: Function,
      default: null
    },
    /* Custom action to execute when user clicks the clear (X) button. */
    clearActionCustom: {
      type: Function,
      default: null
    },
    /* Attribute that indicates if the popper must be append to body. */
    popperAppendToBody: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    /* The text of parent that must be updated by ever input letter. */
    text: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    editValue: {
      type: String,
      default: ''
    },
    maxResults: {
      type: Number,
      default: 20
    }
  },
  watch: {
    localModel(newVal) {
      // always inform parent of current text value
      this.$emit(updateTextEvent, newVal);
      // If strict is false then it must be update the parent model.
      if (!this.strict) {
        this.$emit(updateModelEvent, this.localModel);
      }
    },
    editValue(newVal) {
      // When editValue is cleared from parent, clear the local model
      if (!newVal || newVal === '') {
        this.localModel = '';
        this.list = [];
      }
    },
    model: {
      immediate: true,
      handler(newVal) {
        if (newVal == null) {
          this.localModel = '';
          this.list = [];
        } else if (typeof newVal === 'string' || typeof newVal === 'number') {
          const found = this.list.find(item => item[this.valueField] === newVal);
          if (found) {
            // CAMBIO AQUÍ: Concatenar también en el watch
            let label = found[this.labelField];
            if (this.labelFieldLastWithDash && found[this.labelFieldLastWithDash]) {
              label += ` - ${found[this.labelFieldLastWithDash]}`;
            }
            this.localModel = label;
          } else if (this.url && this.valueField && this.labelField) {
            autocompleteApiService.getList({
              url: this.url,
              searchString: this.editValue || '',
              requestParams: { includeInactive: this.includeInactive }
            }).then(response => {
              if (response && response.data && response.data.length > 0) {
                const filtered = response.data.filter(el => el[this.valueField] === newVal);
                if (filtered.length > 0) {
                  const item = filtered[0];
                  // CAMBIO AQUÍ: Concatenar también en la búsqueda asíncrona
                  // ESTA LÓGICA ES LA QUE ASEGURA EL FORMATO
                  let label = item[this.labelField];
                  if (this.labelFieldLastWithDash && item[this.labelFieldLastWithDash]) {
                    label += ` - ${item[this.labelFieldLastWithDash]}`;
                  }

                  this.localModel = label; // Aquí se pone el "Name - Number"
                  this.list = [item, ...this.list];
                }
              }
            });
          }
        }
      }
    }
  },
  methods: {
    querySearchAsync(queryString, cb) {
      this.$emit(updateTextEvent, queryString);
      if (queryString && queryString.length >= 2 && queryString.trim()) {
        /* if (this.list.length > 0) {
          const filtered = this.list.filter(item => {
            const label = item[this.labelField] ? item[this.labelField].toString().toLowerCase() : '';
            const labelLastWithDash = this.labelFieldLastWithDash && item[this.labelFieldLastWithDash] ? item[this.labelFieldLastWithDash].toString().toLowerCase() : '';
            const searchStr = queryString.toLowerCase();
            return label.includes(searchStr) || labelLastWithDash.includes(searchStr);
          });
          if (filtered.length > 0) {
            cb(filtered);
            return;
          }
        } */
        const data = {
          url: this.url,
          searchString: queryString.trim(),
          requestParams: {
            shipperAccountId: this.shipperAccountId,
            warehouseId: this.warehouseId,
            includeInactive: this.includeInactive,
            maxResults: this.maxResults
          }
        };
        return autocompleteApiService.getList(data).then((response) => {
          if (response && response.data && response.data.length > 0) {
            response.data.forEach((element) => {
              // The value field its necessary by native component to show in the input.
              element.value = element[this.labelField];
              element.value += element[this.labelFieldLastWithDash] ? (` - ${element[this.labelFieldLastWithDash]}`) : '';
            });
            this.list = response.data;
            cb(response.data);
          } else {
            cb([]);
          }
        });
      }
      return false;
    },
    handleSelect(item) {
      // 1. Actualiza el ID/Código en el padre (esto está bien)
      this.$emit(updateModelEvent, item[this.valueField]);

      // 2. Lógica para el texto que se queda en el input
      if (this.labelfieldSelected) {
        this.localModel = item[this.labelfieldSelected];
      } else {
        // Si no hay una prop específica, construimos el "Name - Number"
        let displayLabel = item[this.labelField];
        if (this.labelFieldLastWithDash && item[this.labelFieldLastWithDash]) {
          displayLabel += ` - ${item[this.labelFieldLastWithDash]}`;
        }
        this.localModel = displayLabel;
      }

      if (this.valueFieldAdditional) {
        this.$emit('update:modelAdditional', item[this.valueFieldAdditional]);
      }
      if (this.selectAction) {
        this.selectAction(item);
      }
      this.$emit('select', item);
    },
    clearAll() {
      this.$emit(updateModelEvent, null);
      // notify parent text has been completely cleared
      this.$emit(updateTextEvent, '');
      // Excecute parent clearAction action.
      if (this.clearAction) {
        this.clearAction();
      }
      // Execute custom clear action if provided.
      if (this.clearActionCustom) {
        this.clearActionCustom();
      }
      this.$emit('clear');
    },
    clearParentModel(event) {
      // tab, enter, end, home, left, right
      const isControlKey = constants.KEY_CODE.CONTROL_KEYS_NO_BACKSPACE.find(key => key === event.keyCode);

      if (!isControlKey && this.model && this.strict) {
        this.$emit(updateModelEvent, null);
      }

      if (constants.KEY_CODE.ENTER === event.keyCode && this.enterKeyAction) {
        this.enterKeyAction();
      }
    },
    clearLocalModel() {
      this.localModel = null;
      this.list = [];
    },
    setLocalModel(val) {
      this.localModel = val;
    },
    getLocalModel() {
      return this.localModel;
    },
    selectWithTab() {
      if (this.list.length && this.$refs[autocompletePrincipalRefStr].highlightedIndex >= 0) {
        const item = this.list[this.$refs[autocompletePrincipalRefStr].highlightedIndex];
        this.$refs[autocompletePrincipalRefStr].select(item);
      }
    },
    handleExternalSelect(item, itemList) {
      this.list = itemList || [];
      this.handleSelect(item);
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
.autocomplete-popper {
    min-width: 30%;
}
</style>
